import styled, { css } from "styled-components"

import { fontWeight } from "~/utils/styles"

export const BackgroundContainer = styled.div`
  display: flex;
  background: var(--sky-blue-fade);
  width: 100vw;
  justify-content: center;
  overflow-x: hidden;
`

export const Inner = styled.section`
  position: relative;
  @media print {
    height: 100vh;
    max-height: none;
    justify-content: center;
  }
  width: 100%;
  max-width: var(--max-width-desktop);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 50px clamp(15px, 3vw, 100px);
`

export const SubHeading = styled.h3`
  ${fontWeight(450)};
  font-size: 20px;
  letter-spacing: 2px;
  text-transform: capitalize;
  color: var(--cyan);
  scroll-margin-top: 50px;
`
export const Heading = styled.h1`
  font-size: 42px;
  font-size: var(--step-4);
  font-family: PoppinsVF;
  line-height: 1.2;
  margin: 10px 0 20px 0;
  color: var(--blue);
  z-index: 5;
  span {
    font-size: 42px;
    font-size: var(--step-4);
    font-family: PoppinsVF;
    line-height: 1.2;
    margin: 10px 0 20px 0;
    position: relative;
    width: fit-content;
    z-index: 5;
    ::after {
      content: "";
      display: inline-block;
      z-index: -1;
      position: absolute;
      width: 100%;
      transform: translateY(var(--step-4)) translateX(-100%);
      height: 8px;
      background: var(--gold-transparent-fade);
      border-radius: 7px;
    }
  }
`
export const Text = styled.p`
  color: var(--grey-dark);
  line-height: 30px;
`

export const BoxStyle = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.14);
  background: linear-gradient(
    180deg,
    rgba(231, 243, 250, 0.659) 0%,
    rgba(254, 255, 255, 0.0171615) 99.99%,
    rgba(255, 255, 255, 0) 100%
  );
`

export const GradientStyles = css`
  font-size: var(--step-5);
  width: fit-content;
  letter-spacing: 1px;
  padding-bottom: 10px;
  line-height: var(--step-5);
  ${fontWeight(700)};
  font-family: PoppinsVF;
  display: flex;
  align-items: center;
  ${() =>
    !!window.webkitURL &&
    css`
      background: var(--vibrant-blue-fade);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    `}
  @media print {
    color: var(--blue);
    ${() =>
      !!window.webkitURL &&
      css`
        background: white;
        -webkit-background-clip: border-box;
        -webkit-text-fill-color: var(--blue);
        background-clip: border-box;
        text-fill-color: var(--blue);
      `}
  }
`

export const GradientHeading = styled.h1`
  ${GradientStyles}
`
